export default __webpack_public_path__ + "static/media/add-circle.668a8f54.svg";